import React, { memo } from 'react';

import { useSelector } from 'react-redux';

import { ReactComponent as LibraryIcon } from '../../../../assets/sightx-icons/svg/sx-library.svg';
import { selectors as authSelectors } from '../../../../slices/auth/authSelectors';
import Option from '../Option';

interface IProps {
  href: string;
  isLapsedAccount: boolean;
}

export const LibraryOption = memo((props: IProps) => {
  const sectionSecurityPermissions = useSelector(authSelectors.getSectionSecurityPermissions);

  const { isLapsedAccount, href } = props;

  return <Option
    key="Library"
    href={href}
    disabled={isLapsedAccount}
    disabledByAccessPermission={!sectionSecurityPermissions?.build}
  >
    <LibraryIcon />Library
  </Option>;
});
